import fonts from './fonts';
import responsive from './responsive';
import spacing from './spacing';
export const enum directions {
    top = 1,
    bottom = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    all = 1 | 1 << 1 | 1 << 2 | 1 << 3,
    sides = 1 << 2 | 1 << 3
};

const prefixed = (prefix: string, value: number, multi: number = 1, dir: directions = directions.sides) => ({
    [prefix ? `${prefix}Left` : 'left']:
        (dir & directions.left) === directions.left && value * multi || undefined,
    [prefix ? `${prefix}Right` : 'right']:
        (dir & directions.right) === directions.right && value * multi || undefined,
    [prefix ? `${prefix}Bottom` : 'bottom']:
        (dir & directions.bottom) === directions.bottom && value * multi || undefined,
    [prefix ? `${prefix}Top` : 'top']:
        (dir & directions.top) === directions.top && value * multi || undefined
});

export const fontSize = {
    'Mobile': 15,
    'Tablet': 16,
    'Desktop': 18,
    'Big': 20
}

export default {
    'Body': {
        [responsive.Mobile]: {
            fontSize: fontSize.Mobile
        },
        [responsive.Tablet]: {
            fontSize: fontSize.Tablet
        },
        [responsive.Desktop]: {
            fontSize: fontSize.Desktop
        },
        [responsive.Big]: {
            fontSize: fontSize.Big
        }
    },
    'PaddingGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.BeforeTablet]: prefixed('padding', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterTablet]: prefixed('padding', spacing.Gutter.Desktop, multi, dir),

    }),
    'MarginGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.BeforeTablet]: prefixed('margin', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterTablet]: prefixed('margin', spacing.Gutter.Desktop, multi, dir)
    }),
    'PostionGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.BeforeTablet]: prefixed('', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterTablet]: prefixed('', spacing.Gutter.Desktop, multi, dir)
    }),
    'TextBlocks': {
        maxWidth: 550,
        margin: '0 auto'
    },
    'Introduction': {
        maxWidth: 820,
        margin: '0 auto',
        textAlign: 'center',
        [responsive.BeforeTablet]: {
            fontSize: '1.5rem'
        },
        [responsive.AfterTablet]: {
            fontSize: '1.8rem'
        }
    },
    'Title': {
        ...fonts.Granjon.Normal,
        [responsive.BeforeTablet]: {
            fontSize: '2.5rem'
        },
        [responsive.AfterTablet]: {
            fontSize: '3.6rem'
        }
    },
    'Subtitle_1': {
        ...fonts.Sackers.Medium,
        fontSize: '0.7rem',
        textTransform: 'uppercase'
    },
    'Subtitle_2': {
        ...fonts.Granjon.Normal,
        [responsive.BeforeTablet]: {
            fontSize: '1.5rem'
        },
        [responsive.AfterTablet]: {
            fontSize: '1.8rem'
        }
    },
    'Quote': {
        maxWidth: 550,
        ...fonts.Sackers.Light,
        fontSize: '1rem',
        textTransform: 'uppercase',
        textAlign: 'center'
    },
    'Text': {
        ...fonts.Granjon.Normal,
        fontSize: '1rem'
    },
    'List': {
        ...fonts.Granjon.Normal,
        fontSize: '1rem'
    },
    'Caption': {
        ...fonts.Sackers.Medium,
        fontSize: '0.55rem',
        textTransform: 'uppercase',
        textAlign: 'center'
    },
    'Footer': {
        ...fonts.Sackers.Medium,
        fontSize: '0.4rem',
        textTransform: 'uppercase'
    },
    'Background_Caption': {
        ...fonts.Granjon.Normal,
        fontSize: '1rem'
    },
    'Link': (active: boolean, origin: 'left' | 'center', offset = 0) => ({
        position: 'relative',
        '&:after': {
            content: '""',
            position: 'absolute',
            left: '0',
            top: '100%',
            width: '100%',
            marginTop: offset,
            height: 1,
            background: 'black',
            transform: active ? 'scaleX(1)' : 'scaleX(0)',
            transition: 'all 0.3s ease-in-out',
            transformOrigin: origin
        },
        '&:hover:after': {
            transform: 'scaleX(1)',
        }
    })
};


// WEBPACK FOOTER //
// ./src/constants/stylesheet.ts